export const CHANGE_PASSWORD  = 'CHANGE_PASSWORD '
export const SIGN_IN_POST = 'SIGN_IN_POST'
export const CHANGE_PASSWORD_SEND = 'CHANGE_PASSWORD_SEND'
export const GET_AUTH = 'GET_AUTH'
export const SHOW_LOADER = 'GET_AUTH'
export const HIDE_LOADER= 'GET_AUTH'
export const HIDE_PRELOADER= 'HIDE_PRELOADER'
export const SHOW_PRELOADER= 'SHOW_PRELOADER'
export const GET_USERS= 'GET_USERS'
export const ADD_TECHNICIAN = 'ADD_TECHNICIAN'
export const ADD_USER = 'ADD_USER'
export const GET_ONE_USER = 'GET_ONE_USER'
export const ADD_DEVICE = 'ADD_DEVICE'
export const GET_DEVICE = 'GET_DEVICE'
export const GET_COMPONENTS = 'GET_COMPONENTS'
export const GET_SINGLE_DEVICE = 'GET_SINGLE_DEVICE'
export const CHANGE_SINGLE_DEVICE =  'CHANGE_SINGLE_DEVICE'
export const TECHNICIAN_TOKEN = 'TECHNICIAN_TOKEN'
export const GET_DEVICES_COUNTERS = 'GET_DEVICES_COUNTERS'
export const GET_DEVICE_USER = 'GET_DEVICE_USER'
export const GET_SINGLE_DEVICE_USER = 'GET_SINGLE_DEVICE_USER'
export const GET_COUNTER = 'GET_COUNTER'
export const GET_COUNTER_USER = 'GET_COUNTER_USER'
export const GET_COMPONENTS_IS_ADMIN = 'GET_COMPONENTS_IS_ADMIN'
export const GET_SETTINGS_BASIC = 'GET_SETTINGS_BASIC'
export const GET_FILTRATE_USERS = 'GET_FILTRATE_USERS'
export const CLEAR_FILTRATE_USERS = 'CLEAR_FILTRATE_USERS'
export const GET_SETTINGS_EXTENDED = "GET_SETTINGS_EXTENDED"
export const GET_CHANNELS = "GET_CHANNELS" 



